var React = require('react');

function LampFloor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224,224V448H160V224Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256,448H128c-28.42,0-54.95,18.53-63.3,44.16C61.48,502,69.88,512,80.26,512H303.74c10.38,0,18.78-10,15.56-19.84C311,466.53,284.42,448,256,448ZM381.38,179.39l-68.58-160A32,32,0,0,0,283.39,0H100.61A32,32,0,0,0,71.2,19.39l-68.58,160A32,32,0,0,0,32,224H352A32,32,0,0,0,381.38,179.39Z","className":"fa-primary","key":2})]);
}

LampFloor.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = LampFloor;

LampFloor.default = LampFloor;
